import { jsx, jsxs } from "react/jsx-runtime";
import { ClickAwayListener, MenuItem, Paper, Popper, useThemeProps } from "@mui/material";
import { TextField } from "../../components/index.js";
import { MenuList } from "./components/MenuList.js";
import { Root } from "./components/Root.js";
import { useDurationInput } from "./hooks/useDurationInput/useDurationInput.js";
function DurationInput(inProps) {
  const props = useThemeProps({ name: "DurationInput", props: inProps });
  const { slotProps } = props;
  const {
    textFieldProps,
    rootProps,
    dropdownOptions,
    dropdownProps,
    popperProps,
    paperWidth,
    dropdownSelectedIndex,
    clickAwayProps
  } = useDurationInput(props);
  return /* @__PURE__ */ jsxs(Root, { ...rootProps, children: [
    /* @__PURE__ */ jsx(TextField, { ...textFieldProps }),
    /* @__PURE__ */ jsx(Popper, { ...popperProps, children: /* @__PURE__ */ jsx(ClickAwayListener, { ...clickAwayProps, children: /* @__PURE__ */ jsx(Paper, { style: { width: paperWidth }, children: /* @__PURE__ */ jsx(MenuList, { ...slotProps?.menuList, children: dropdownOptions.map((option, index) => /* @__PURE__ */ jsx(
      MenuItem,
      {
        value: option.value,
        onClick: dropdownProps.onClick,
        selected: dropdownSelectedIndex === index,
        "data-int-value": option.value,
        children: option.label
      },
      option.value
    )) }) }) }) })
  ] });
}
export {
  DurationInput
};
//# sourceMappingURL=DurationInput.js.map
